module.exports = __webpack_public_path__ + "media/images/mime_types/file-powerpoint-o-8ce6c3ce5d5138d2bc6c6ac434dd8e91.png";